import React, { useState } from 'react';
import { FaDownload, FaDatabase } from "react-icons/fa";
import { typeIcons } from '../components/Utils';
import axios from "../axiosConfig";
import './Export.css';
import PageTitle from "../components/PageTitle";

const Export = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // Handle export download
  const handleExport = async (filetype) => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await axios.get(`/export/?filetype=${filetype}`, {
        withCredentials: true,
        responseType: 'blob', // Important for file downloads
      });

      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Set filename based on filetype
      const timestamp = new Date().toISOString().slice(0, 19).replace(/[:]/g, '-');
      const filename = `ft_portal_export_${timestamp}.${filetype}`;
      link.setAttribute('download', filename);
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      // Cleanup
      window.URL.revokeObjectURL(url);
      
      setSuccess(`${filetype.toUpperCase()} export downloaded successfully!`);
    } catch (err) {
      console.error('Export failed:', err);
      setError(`Failed to export ${filetype.toUpperCase()} file. Please try again.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-layout">
      <PageTitle>
        {typeIcons['export'] || <FaDownload />} Export Data
      </PageTitle>
      
      <div className="page-content">

        {/* Status Messages */}
        {error && (
          <div style={{ 
            padding: '10px', 
            marginBottom: '20px', 
            backgroundColor: '#f8d7da', 
            color: '#721c24', 
            border: '1px solid #f5c6cb', 
            borderRadius: '4px' 
          }}>
            {error}
          </div>
        )}

        {success && (
          <div style={{ 
            padding: '10px', 
            marginBottom: '20px', 
            backgroundColor: '#d4edda', 
            color: '#155724', 
            border: '1px solid #c3e6cb', 
            borderRadius: '4px' 
          }}>
            {success}
          </div>
        )}

        <div className="export-options">
          <h3>Available Export Formats</h3>

          {/* SQL Export Option */}
          <div className="export-card">
            <div className="export-card-header">
              <h4><FaDatabase /> SQL Database Export</h4>
            </div>
            <div className="export-card-content">
              <p><em>Format:</em> SQL (.sql)</p>
              <p><em>Description:</em> Complete database backup with INSERT statements that can recreate the entire database from scratch.</p>
              <button 
                onClick={() => handleExport('sql')} 
                disabled={loading}
                className="export-btn sql-btn"
              >
                {loading ? 'Generating...' : 'Download SQL Export'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Export;
